import React from 'react'

interface ChannelImageProps {
    channel: {
        name: string;
        logo_url: string;
    };
    size?: "small" | "medium" | "large";
    className?: string;
}


const ChannelImage: React.FC<ChannelImageProps> = ({
    channel,
    size = "medium",
    className = "channel-select-img",
}) =>  {
    const sizeMap = {
        small: { width: "16px", height: "16px" },
        medium: { width: "18px", height: "17px" },
        large: { width: "20px", height: "20px" },
    };

    return (
        <img
            className={className}
            src={channel.logo_url}
            alt={channel.name}
            style={{
                objectFit: "contain",
                width: sizeMap[size].width,
                height: sizeMap[size].height,
            }}
        />
    );
};

export default ChannelImage